import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import MachineAPI from '~/api/machine-api';
import { partialUpdateAsset } from '~/ducks/asset-updates/actions';
import createCaughtAsyncThunk from '~/utils/create-action/create-caught-async-thunk';
import { defaultState } from './data/ChangeMachineNameState';

export const saveMachineName = createCaughtAsyncThunk<
  any,
  {
    machineId: AssetId;
    machineName: string;
  }
>('saveMachineName', async (args, thunkAPI) => {
  await MachineAPI.changeMachineName(args.machineId, args.machineName);
  thunkAPI.dispatch(
    partialUpdateAsset({
      assetId: args.machineId,
      asset: {
        assetDetails: {
          name: args.machineName,
        },
      },
      forceUpdate: false,
    })
  );
});

const slice = createSlice({
  name: 'change-machine-name',
  initialState: defaultState,
  reducers: {
    toggleChangeMachineNameModalOpen: (state) => {
      state.modalIsOpen = !state.modalIsOpen;
      state.isChanged = false;
    },
    setMachineForChangeNameModal: (
      state,
      action: PayloadAction<{ machineId: AssetId; machineName: string }>
    ) => {
      state.machineId = action.payload.machineId;
      state.machineName = action.payload.machineName;
      delete state.error;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveMachineName.pending, (state) => {
        state.isLoading = true;
        state.isChanged = false;
        delete state.error;
      })
      .addCase(saveMachineName.fulfilled, () => {
        return {
          ...defaultState,
          isChanged: true,
        };
      })
      .addCase(saveMachineName.rejected, (state, action) => {
        state.isLoading = false;
        if (action.meta.aborted) {
          return;
        }
        state.error = action.payload;
      });
  },
});

export const {
  setMachineForChangeNameModal,
  toggleChangeMachineNameModalOpen,
} = slice.actions;

export default slice.reducer;
